import { Button, Flex, Select } from "@mantine/core";
import SRD_DataTable from "components/DataTable";
import { userState } from "pages/Login/atom/userState";
import { useState } from "react";
import { useQuery } from "react-query";
//import { useNavigate } from "react-router-dom";
import { DatePickerInput } from '@mantine/dates';
//import '@mantine/dates/styles.css';
import { getChangesLog } from "pages/Admin/Changes/apis/adminChangesApis";
import { getGroupList } from "pages/Admin/Group/apis/adminGroupApis";
import { useRecoilState } from "recoil";

function ChangeLogDataTable() {
  //const navigate = useNavigate();
  const [user, setUser] = useRecoilState(userState);
  const level = Number(user?.fn_level);
  const adminLevel = [0].includes(level);
  const loginGroupId = adminLevel ? null : user?.fn_group_id;
  const [group, setGroup] = useState(loginGroupId);
  const [data, setData] = useState([]);
 // const [requestQuery, setRequestQuery] = useState();
  //const [page, setPage] = useState(1);
  const adminOption = {value : null, label : "전체 그룹"};

  const thisDate = new Date();
  const aWeeksAgo = new Date(new Date() -7 * 24 * 3600 * 1000);
  const [selectedDate, setSelectedDate] = useState([aWeeksAgo,thisDate]);


  const { data: groupList } = useQuery(
    "groupList",
    () =>
      getGroupList(1000, 1).then((res) => 
        res.map((item) => ({ value: item.group_id, label: item.group_nm }))
      ),
    {
      staleTime: 5 * 60 * 1000, // 5분
    }
  );

  //useEffect(() => {
 //   getData();
 //   setRequestQuery(false);
 // }, [group,requestQuery]);

  const selectOverallGroup = () => {
    if (!adminLevel || groupList?.length < 1) return;
    const grList = groupList?.map((record) => record.label);
    if( !grList?.includes("전체 그룹") ){
      groupList?.splice(0,0,adminOption);
    } 
  }
  selectOverallGroup();

  function getGroupNm(id) {
    let result ="NA";
    if(groupList?.length < 1) return result;
    let grp = groupList.find((v) => v.value === id.toString());
    if (grp != undefined){
      result = grp.label;
    }
    return result;
  }

 // useEffect(() => {
 //   setPage(1);
 // }, [group]);

 const pad = n => n < 10 ? '0' + n : n;

 function formatTimestamp(timestamp) {
 //  const unixTimestamp = new Date(timestamp * 1000);
   const unixTimestamp = new Date(timestamp);
   const year = unixTimestamp.getFullYear();
   const month = unixTimestamp.getMonth() + 1;
   const day = unixTimestamp.getDate();
   const hour = unixTimestamp.getHours();
   const min = unixTimestamp.getMinutes();
   const sec = unixTimestamp.getSeconds();
 
   return `${year}년${pad(month)}월${day}일 ${hour}시${min}분${pad(sec)}초`;
 };

  const columns = [
    {
      accessor: "index",
      title: "번호",
      textAlignment: "center",
    //  width: 30,
      render: (record) => data.indexOf(record)+1,
    },
    {
      accessor: "log_date",
      title: "일시",
      textAlignment: "center",
      width: 90,
      cellsStyle: () => ({
        fontSize:'75%',
      }),
      render: ({ log_date }) => formatTimestamp(log_date),
    },
    {
      accessor: "user_id",
      title: "사용자 ID",
      textAlignment: "center",
    },
    {
      accessor: "group_id",
      title: "그룹명",
      textAlignment: "center",
      render: ({ group_id }) => getGroupNm(group_id),
    },
    {
      accessor: "category",
      title: "분류",
    //  width: 80,
      textAlignment: "center",
    },
    {
      accessor: "type",
      title: "유형",
      textAlignment: "center",
    },
    {
      accessor: "changes",
      title: "변경 내용",
    //  textAlignment: "center",
    },
  ];

  const getData = () => {
    if (selectedDate.length < 2) return;
    const fr_date = selectedDate[0].toISOString().slice(0, 10).replace(/-/g, ""); //"20230424"
    const to_date = selectedDate[1].toISOString().slice(0, 10).replace(/-/g, ""); //"20230424"  
    getChangesLog(group,fr_date,to_date)
    .then(res => setData(res));
  };

//  const onClick = () => {
//    setRequestQuery(true);
 // };

  const RegisterButton = () => {
    return (
      <Button  onClick={getData}>
        검색
      </Button>
    );
  };

  const SearchBar = () => {
    const handleGroupChange = (value) => setGroup(value);

    return (
      <Flex gap={15} mb={10} align="center" style={{ width: "100%" }}>
        <Select
          data={groupList ?? []}
          value={group}
          placeholder="그룹선택"
          onChange={handleGroupChange}
          style={{
            flex: 1,
          }}
        />
        검색 기간:
        <DatePickerInput
          type="range"
          valueFormat="YYYY년MM월DD일"
    //      defaultValue={new Date()}
       //   label="검색 범위"
          placeholder="시작과 끝 날짜를 선택하세요"
          value={selectedDate}
          onChange={setSelectedDate}
          mx="auto"
          maw={400}
          zIndex={2000}
        />
        <RegisterButton /> 
      </Flex>
    );
  };

  return (
    <div style={{ width: "100%", height: "900px"}}>
      <SRD_DataTable 
        searchBar={<SearchBar />}
        data={data} 
        columns={columns} 
    //    page={page} 
    //    setPage={setPage} 
      />
    </div>
  );
}

export default ChangeLogDataTable;
